import React, { useState, } from 'react';
import { Row, Col, Spin, Form, Typography, Button, message } from 'antd';
import { useForm } from 'react-hook-form';
import { InputPassword } from '../../../../atoms/FormElement';
import { LoadingOutlined } from '@ant-design/icons';
import { changePassword } from '../../../../../services/dashboard';
import { useTranslate } from 'Translate';

const antIcon = <LoadingOutlined spin />;
const { Title } = Typography;

export default (props) => {
  const { title, onClose } = props;
  const [load, setLoad] = useState(false);
  const { control, formState: { errors }, handleSubmit, watch, reset } = useForm();
  const i18n = useTranslate();
  const { t } = i18n;

  let checkPassword =  watch('password');

  const onSubmitHandler = (values) => {
    setLoad(true);
    const payload = {
      current_password: values?.current,
      new_password: values?.password,
    };
    changePassword(payload)
      .then((res) => {
        if (res?.data?.code === 200) {
          message.success(t("General.password_changed_success"));
          setLoad(false);
          reset();
          onClose();
        } else {
          message.error(res.data.message);
          setLoad(false);
        }
      })
      .catch((e) => {
        message.error(e.message ?? t("General.something_went_wrong"));
        setLoad(false);
      });
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={load}>
      <Form scrollToFirstError layout="vertical" onFinish={handleSubmit(onSubmitHandler)}>
        <Row gutter={[20, 20]} justify="center">
          <Col span={24}>
            <Row gutter={24} justify="center">
              <Col>
                <Title level={3} className="mb-0">
                  {title}
                </Title>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <InputPassword
              isRequired={true}
              fieldname="current"
              label={t("General.current_password")}
              control={control}
              initValue=""
              iProps={{
                size: 'large',
              }}
              rules={{
                required: t("General.pls_enter_password"),
              }}
              validate={errors.current && 'error'}
              validMessage={errors.current && errors.current.message}
            />
          </Col>
          <Col span={24}>
            <InputPassword
              isRequired={true}
              fieldname="password"
              label={t("General.new_password")}
              control={control}
              initValue=""
              iProps={{
                size: 'large',
              }}
              rules={{
                required: t("General.pls_enter_password"),
              }}
              validate={errors.password && 'error'}
              validMessage={errors.password && errors.password.message}
            />
          </Col>
          <Col span={24}>
            <InputPassword
              isRequired={true}
              fieldname="confirm"
              label={t("General.retype_password")}
              control={control}
              initValue=""
              iProps={{
                size: 'large',
              }}
              rules={{
                required: t("General.pls_confirm_password"),
                validate: (value) => value === checkPassword || t("General.password_not_match")
              }}
              validate={errors.confirm ? 'error' : ''}
              validMessage={errors.confirm && errors.confirm.message}
            />
          </Col>
          <Col span={24}>
            <Row gutter={24} align="middle">
              <Col span={12}>
                <Button type="primary" size="large" className="w-100 black-btn" htmlType="button" onClick={() => { reset(); onClose();}}>
                  {t("General.close")}
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className="w-100 green-btn"
                >
                  {t("General.save")}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};
